<template>
  <div class="tenant-logo">
    <img v-if="logoUrl" :src="logoUrl" class="tenant-logo-image" :alt="tenantName">
    <div v-else class="tenant-logo-default">
      <span>{{ defaultText }}</span>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

const tenantStateMappers = createNamespacedHelpers('tenant');

export default {
  name: 'TenantLogo',
  props: {
    height: {
      type: String,
      default: '40px'
    },
    defaultText: {
      type: String,
      default: 'MSP'
    }
  },
  computed: {
    ...tenantStateMappers.mapGetters({
      currentTenant: 'getSelectedTenant'
    }),
    logoUrl() {
      return this.currentTenant && this.currentTenant.logo ? this.currentTenant.logo : null;
    },
    tenantName() {
      return this.currentTenant ? this.currentTenant.name : this.defaultText;
    }
  },
  mounted() {
    // Fetch current tenant if not available
    if (!this.currentTenant) {
      this.fetchTenant();
    }
  },
  methods: {
    ...tenantStateMappers.mapActions(['getTenantById']),
    fetchTenant() {
      // Import tenantService to get tenant data
      import('@/services/TenantService.class').then(({ tenantService }) => {
        tenantService.getSelf()
          .then(response => {
            // Commit this to the store
            this.$store.commit('tenant/setSelectedTenant', response.data);
          })
          .catch(error => {
            console.error('Error fetching tenant:', error);
          });
      });
    }
  }
}
</script>

<style scoped>
.tenant-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: v-bind(height);
}

.tenant-logo-image {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
}

.tenant-logo-default {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-weight: bold;
  font-size: 18px;
  color: #409EFF;
}
</style>
